import { render, staticRenderFns } from "./shoppe.vue?vue&type=template&id=28a6a500&scoped=true"
import script from "./shoppe.vue?vue&type=script&lang=js"
export * from "./shoppe.vue?vue&type=script&lang=js"
import style0 from "./shoppe.vue?vue&type=style&index=0&id=28a6a500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6a500",
  null
  
)

export default component.exports